// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Weekday from "../../../../to-be-migrated/domain/types/common/Weekday.bs.js";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as FilterType from "../../../app/entity/FilterType.bs.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CampaignStatusType from "../../../app/entity/CampaignStatusType.bs.js";
import * as ListUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ListUtils.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function getFilterInfo(v) {
  switch (v) {
    case /* AllocationRadius */0 :
        return "Haversine or aerial radius beyond which drivers will be filtered out. Centre of circle is the pickup point.";
    case /* DryRun */1 :
        return " If driver is beyond threshold dry run x (estimated dry run > x km), then dry run ratio is applied where, ratio*estimated dry run > trip distance. Drivers who fulfil this logic get filtered out. Uses actual on road route and not haversine.";
    case /* MaxDryRun */2 :
        return "On road distance from current driver location to pickup beyond which drivers will be filtered out";
    
  }
}

function formatTime(hour, minute) {
  var formattedHour = hour < 10 ? "0" + String(hour) : String(hour);
  var formattedMinute = minute < 10 ? "0" + String(minute) : "" + String(minute);
  return formattedHour.concat(":", formattedMinute);
}

function mapIdstoZones(zones, zone_ids) {
  return List.map((function (z) {
                return z.description;
              }), List.filter(function (z) {
                    return List.exists((function (i) {
                                  return i === z.id;
                                }), zone_ids);
                  })(zones));
}

function mapIdsClusters(clusters, cluster_ids) {
  return List.map((function (c) {
                return c.description;
              }), List.filter(function (c) {
                    return List.exists((function (i) {
                                  return i === c.id;
                                }), cluster_ids);
                  })(clusters));
}

function getCreatorInfo(creatorInfo) {
  return {
          actor: {
            name: creatorInfo.actor.name,
            email_id: creatorInfo.actor.email_id
          },
          time: Timestamp$Catalyst.toString(creatorInfo.time, "DD-MMM-YYYY")
        };
}

function getApproverInfo(approverInfo) {
  if (approverInfo !== undefined) {
    return {
            actor: {
              name: approverInfo.actor.name,
              email_id: approverInfo.actor.email_id
            },
            time: Timestamp$Catalyst.toString(approverInfo.time, "DD-MMM-YYYY")
          };
  }
  
}

function getViewModel(campaign, zones, clusters) {
  console.log("**********", campaign);
  var time = campaign.effective_till;
  var match = List.length(campaign.days_of_week);
  var tmp;
  if (match !== 7) {
    var days_in_string = List.map(Weekday.toString, campaign.days_of_week);
    tmp = ListUtils$Catalyst.toString(days_in_string, (function (a) {
            return $$String.sub(a, 0, 3);
          }), undefined, undefined);
  } else {
    tmp = "All";
  }
  var match$1 = campaign.day_start_hour;
  var match$2 = campaign.day_start_min;
  var match$3 = campaign.day_end_hour;
  var match$4 = campaign.day_end_min;
  var match$5 = campaign.sub_type;
  var tmp$1;
  switch (match$5) {
    case /* AllocationRadius */0 :
        var v = campaign.values.auto;
        var v$1 = campaign.values.manual;
        var v$2 = campaign.values.radius_delta;
        tmp$1 = {
          left_value: v !== undefined ? v : -1,
          right_value: v$1 !== undefined ? v$1 : -1,
          radius_delta: v$2 !== undefined ? v$2 : undefined
        };
        break;
    case /* DryRun */1 :
        var v$3 = campaign.values.threshold;
        var v$4 = campaign.values.ratio;
        var v$5 = campaign.values.radius_delta;
        tmp$1 = {
          left_value: v$3 !== undefined ? v$3 : -1,
          right_value: v$4 !== undefined ? v$4 : -1,
          radius_delta: v$5 !== undefined ? v$5 : undefined
        };
        break;
    case /* MaxDryRun */2 :
        var v$6 = campaign.values.auto;
        var v$7 = campaign.values.manual;
        var v$8 = campaign.values.radius_delta;
        tmp$1 = {
          left_value: v$6 !== undefined ? v$6 : -1,
          right_value: v$7 !== undefined ? v$7 : -1,
          radius_delta: v$8 !== undefined ? v$8 : undefined
        };
        break;
    
  }
  var clusters$1 = campaign.cluster_ids;
  var tmp$2;
  if (clusters$1 !== undefined) {
    var match$6 = clusters$1.length;
    tmp$2 = match$6 !== 0 ? "Cluster" : "Zone";
  } else {
    tmp$2 = "Zone";
  }
  var validations = campaign.validation;
  return {
          id: campaign.id,
          name: campaign.name,
          geo_region_id: campaign.geo_region_id,
          vehicle_id: campaign.vehicle_id,
          _type: campaign._type,
          sub_type: FilterType.toDisplayString(campaign.sub_type),
          zones: mapIdstoZones(zones, $$Array.to_list(campaign.zone_ids)),
          clusters: mapIdsClusters(clusters, $$Array.to_list(Belt_Option.getWithDefault(campaign.cluster_ids, []))),
          status: CampaignStatusType.toString(campaign.status),
          priority: campaign.priority,
          pending_priority: campaign.pending_priority,
          effective_from: Timestamp$Catalyst.toString(campaign.effective_from, "DD-MMM-YYYY"),
          effective_till: time !== undefined ? Timestamp$Catalyst.toString(Caml_option.valFromOption(time), "DD-MMM-YYYY") : "N/A",
          days_of_week: tmp,
          day_start_time: match$1 !== undefined && match$2 !== undefined ? formatTime(match$1, match$2) : "N/A",
          day_end_time: match$3 !== undefined && match$4 !== undefined ? formatTime(match$3, match$4) : "N/A",
          filter: tmp$1,
          creation_info: getCreatorInfo(campaign.creation_info),
          approval_info: getApproverInfo(campaign.approval_info),
          filter_info: getFilterInfo(campaign.sub_type),
          campaign_type: tmp$2,
          validation: validations !== undefined ? ({
                validations: Belt_Array.map(validations.validations, (function (validation) {
                        return {
                                validation_type: validation.validation_type,
                                segment_names: validation.segment_names
                              };
                      }))
              }) : undefined
        };
}

var VMMapper = {
  getViewModel: getViewModel
};

function getValidationDisplayText(validations) {
  return Belt_Array.map(validations.validations, (function (validation) {
                  return validation.validation_type + ": " + validation.segment_names.join(", ");
                })).join(" | ");
}

export {
  getFilterInfo ,
  formatTime ,
  mapIdstoZones ,
  mapIdsClusters ,
  getCreatorInfo ,
  getApproverInfo ,
  VMMapper ,
  getValidationDisplayText ,
  
}
/* Timestamp-Catalyst Not a pure module */
